import { query } from 'firebase/firestore'
import type { InvoiceLine } from '~/models'
import { PaginatedArrayService } from './serviceLivePaginatedArray'

export class InvoiceLineService extends PaginatedArrayService<InvoiceLine> {
  private _collection

  constructor() {
    super('Invoices')

    const { collection } = useFirebase()
    this._collection = collection
  }

  public listenForInvoiceId(invoiceId: string): void {
    const listenQuery = query(
      this._collection(`Invoices/${invoiceId}/InvoiceLines`),
    )
    this.listen(listenQuery)
  }
}
